import React from 'react';
import '../template-file-css/document-file-template.css'; 


export const C3_BiopsychosocialAssessment = ({
    itemsRef,
    showErrorFor, 
}) => {

    return (
        <form id='C3_BiopsychosocialAssessment' className='file-pdf-document'>
            <div className='file-template'> 

            <p className='w-750'><h3>Common Items</h3></p>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>History of Present Problem(s) </span>
            <span className='small'>(When began, duration/intensity of symptoms, stressors/precipitants, list participants
                conception of presenting problems and what the participant perceives to be the important issue to be addressed): </span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtHistoryPresentProblem' name='txtHistoryPresentProblem' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Prior MH/SA/DD </span>
            <span className='small'>(Include residential treatment, inpatient, outpatient, etc.):</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtPriorMhSaDd' name='txtPriorMhSaDd' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>History of Traumatic Events </span>
            <span className='small'>(Consider neglect or abuse, violence, significant losses, accidents, etc.):</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtHistoryTraumaticEvents' name='txtHistoryTraumaticEvents' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Current Living Situation </span>
            <span className='small'>(Where with whom relationship, etc.):</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentLivingSituation' name='txtCurrentLivingSituation' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Education History </span>
            <span className='small'>(Consider special education, behavior problems, grade level/current or achieved, school, attitude etc.):</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtEducationHistory' name='txtEducationHistory' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Vocational History </span>
            <span className='small'> (Current employment, military, vocational difficulties, handicaps, if unemployed/work plan etc.):</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtVocationalHistory' name='txtVocationalHistory' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Family History </span>
            <span className='small'>(Include any MH/SA/DD history of biological family, immediate family/significant others, diagnosis, treatment, etc.):</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtFamilyHistory' name='txtFamilyHistory' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Social History </span>
            <span className='small'>(Include friendships/significant relationships, religious and cultural activities, hobbies, recreation etc.):</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtSocialHistory' name='txtSocialHistory' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Transcultural Factors</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtTransculturalFactors' name='txtTransculturalFactors' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'><h3>Presenting Problem(s) and Requested Service(s)</h3></p>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>What is/are presenting problem(s)? </span>
            <span className='small'>(Why are they here? In client's own words when possible.):</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtWhatIsPresentingProblem' name='txtWhatIsPresentingProblem' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Describe precipitating events</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtDescribePrecipitatingEvents' name='txtDescribePrecipitatingEvents' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>What service(s) is the client requesting?</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtWhatServiceClientRequesting' name='txtWhatServiceClientRequesting' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'># of People in Family</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtPeopleInFamily' name='txtPeopleInFamily' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Adjusted Monthly Income</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtAdjustedMonthlyIncome' name='txtAdjustedMonthlyIncome' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Spiritual Variables</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtSpiritualVariables' name='txtSpiritualVariables' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Cultural Variables</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCulturalVariables' name='txtCulturalVariables' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'><h3>Lifespan/Developmental History</h3></p>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>What is the client's prenatal history? </span>
            <span className='small'>(Include any substance abuse, physical abuse, medications, and illnesses
                during Mother's pregnancy, prenatal exposure to alcohol, tobacco and other drugs.):</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtClientPrenatalHistory' name='txtClientPrenatalHistory' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'><h3>Presenting Problem(s) and Requested Service(s)</h3></p>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Health at birth </span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtHealthAtBirth' name='txtHealthAtBirth' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Developmental milestones </span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtDevelopmentalMilestones' name='txtDevelopmentalMilestones' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><input type='checkbox' id='cbWithinNormalLimits' name='cbWithinNormalLimits' className='add-only' value='WithinNormalLimits' /> Within normal limits?</td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Special services received during lifetime </span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtSpecialServicesReceivedDuringLifetime' name='txtSpecialServicesReceivedDuringLifetime' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Other lifespan/developmental issues </span><span className='small'>(Include mid-life, senior/elder, other issues) </span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtOtherLifespanDevelopmentalIssues' name='txtOtherLifespanDevelopmentalIssues' className='add-only' /></td>
    </tr>
</table>


<p className='w-750'><h3>Education Assessment</h3></p>

<table>
    <tr>
        <td className='w-500'><span className='eleHeader'>School currently attending </span></td>
        <td className='w-250'><span className='eleHeader'>Grade </span></td>
    </tr>
    <tr>
        <td className='w-500'><input type='text' id='txtSchoolCurrentlyAttending' name='txtSchoolCurrentlyAttending' className='add-only' /></td>
        <td className='w-250'><input type='text' id='txtGrade' name='txtGrade' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Has the client ever been suspended or expelled from school and/or bus? </span>
            <span className='small'>(Include both in-school suspensions and
                out-of-school suspensions) If so, include the number of times, dates of suspension and duration of suspension.</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtExpelledFromSchoolOrBus' name='txtExpelledFromSchoolOrBus' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Does the client have frequent absences? </span>
            <span className='small'> (Include the number of times consumer has been absent.)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtClientFrequentAbsences' name='txtClientFrequentAbsences' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Is the client currently failing, and has the client ever been retained? </span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtClientCurrentlyFailing' name='txtClientCurrentlyFailing' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Is the client in special education classes? </span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtClientInSpecialEducation' name='txtClientInSpecialEducation' className='add-only' /></td>
    </tr>
</table>


<p className='w-750'><h3>Family of Origin History</h3></p>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Family's current and past psychiatric history </span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtClientsPsycHistory' name='txtClientsPsycHistory' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Family's and client's physical/sexual/emotional abuse history </span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtClientAbuseHistory' name='txtClientAbuseHistory' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Family's substance use/abuse history </span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtClientSubstanceAbuseHistory' name='txtClientSubstanceAbuseHistory' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Client's Current and Significant Past Supports </span>
            <span className='small'>(Social supports, family supports, significant relationships, religious
                and spiritual supports/affiliations.)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtClientSupportAffiliations' name='txtClientSupportAffiliations' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Other Agencies/Systems Involved With </span>
            <span className='small'>(List agencies client is involved with or receiving services from. For
                example: Dept of Rehab, CalWORKs, ASOC, etc. Include the name of the agency and primary contact person.)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtOtherAgencies' name='txtOtherAgencies' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Client's Legal History </span>
            <span className='small'>(Describe and, if currently involved, give name of probation officer, parole office, or case
                manager and estimated start and end dates.)
            </span>
        </td>
    </tr>
    <tr>
        <td className='w-187'><input type='checkbox' id='cbInformalProbation' name='cbInformalProbation' className='add-only' value='InformalProbation' /> Informal Probation</td>
        <td className='w-187'><input type='checkbox' id='cbFormalProbation' name='cbFormalProbation' className='add-only' value='FormalProbation' /> Formal Probation</td>
        <td className='w-187'><input type='checkbox' id='cbParole' name='cbParole' className='add-only' value='Parole' /> Parole</td>
        <td className='w-187'><input type='checkbox' id='cbChildWelfareServices' name='cbChildWelfareServices' className='add-only' value='ChildWelfareServices' /> Child Welfare Services</td>
    </tr>
    <tr>
        <td className='w-187'><input type='checkbox' id='cbConservatorship' name='cbConservatorship' className='add-only' value='Conservatorship' /> Conservatorship</td>
        <td className='w-187'><input type='checkbox' id='cbDui' name='cbDui' className='add-only' value='Dui' /> D. U. I.</td>
        <td className='w-187'><input type='checkbox' id='cbRestrainingOrder' name='cbRestrainingOrder' className='add-only' value='RestrainingOrder' /> Restraining Order</td>
        <td className='w-187'><input type='checkbox' id='cbNoneReported' name='cbNoneReported' className='add-only' value='NoneReported' /> None reported</td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Describe and, if currently involved, give name of probation officer, parole office, or case manager and estimated
            start and end dates</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtClientLegalHistoryDescribe' name='txtClientLegalHistoryDescribe' className='add-only' /></td>
    </tr>
</table>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Client's Substance Use</span>
            <span className='small'>(Alcohol and other drugs, check all that apply)</span>
        </td>
    </tr>
    <tr>
        <td className='w-187'><input type='checkbox' id='cbCaffeine' name='cbCaffeine' className='add-only' value='Caffeine' /> Caffeine</td>
        <td className='w-187'><input type='checkbox' id='cbTobacco' name='cbTobacco' className='add-only' value='Tobacco' /> Tobacco</td>
        <td className='w-187'><input type='checkbox' id='cbInhalants' name='cbInhalants' className='add-only' value='Inhalants' /> Inhalants</td>
        <td className='w-187'><input type='checkbox' id='cbHallucinogens' name='cbHallucinogens' className='add-only' value='Hallucinogens' /> Hallucinogens</td>
    </tr>
    <tr>
        <td className='w-187'><input type='checkbox' id='cbMarijuana' name='cbMarijuana' className='add-only' value='Marijuana' /> Marijuana</td>
        <td className='w-187'><input type='checkbox' id='cbStimulants' name='cbStimulants' className='add-only' value='Stimulants' /> Stimulants</td>
        <td className='w-187'><input type='checkbox' id='cbSedatives' name='cbSedatives' className='add-only' value='Sedatives' /> Sedatives</td>
        <td className='w-187'><input type='checkbox' id='cbTranquillizers' name='cbTranquillizers' className='add-only' value='Tranquillizers' /> Tranquillizers</td>
    </tr>
    <tr>
        <td className='w-187'><input type='checkbox' id='cbCocaine' name='cbCocaine' className='add-only' value='Cocaine' /> Cocaine</td>
        <td className='w-187'><input type='checkbox' id='cbBarbiturates' name='cbBarbiturates' className='add-only' value='Barbiturates' /> Barbiturates</td>
        <td className='w-187'><input type='checkbox' id='cbMethamphetamines' name='cbMethamphetamines' className='add-only' value='Methamphetamines' /> Methamphetamines</td>
        <td className='w-187'><input type='checkbox' id='cbOpiates' name='cbOpiates' className='add-only' value='Opiates' /> Opiates</td>
    </tr>
    <tr>
        <td className='w-187'><input type='checkbox' id='cbMethadone' name='cbMethadone' className='add-only' value='Methadone' /> Methadone</td>
        <td className='w-375'><input type='checkbox' id='cbOverTheCounter' name='cbOverTheCounter' className='add-only' value='OverTheCounter' /> Over-the-counter medication</td>
    </tr>
    <tr>
        <td className='w-375'><input type='checkbox' id='cbPrescriptionMedicationAlcohol' name='cbPrescriptionMedicationAlcohol' className='add-only' value='PrescriptionMedicationAlcohol' /> Prescription Medication Alcohol</td>
        <td className='w-187'><input type='checkbox' id='cbSubstanceUseOther' name='cbSubstanceUseOther' className='add-only' value='SubstanceUseOther' /> Other</td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Client's history of withdrawal, DTs, blackouts (loss of time), seizures, etc. (If applicable)</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtClientHistoryBlackoutSeizures' name='txtClientHistoryBlackoutSeizures' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Ask and record the response to, "What happens when you stop using?"</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtWhatHappensWhenStopUsing' name='txtWhatHappensWhenStopUsing' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-500'><span className='eleHeader'>What is the longest period of sobriety?</span></td>
        <td className='w-250'><span className='eleHeader'>When</span></td>
    </tr>
    <tr>
        <td className='w-500'><input type='text' id='txtLongestPeriodOfSobriety' name='txtLongestPeriodOfSobriety' className='add-only' /></td>
        <td className='w-250'><input type='text' id='txtLongestPeriodOfSobrietyWhen' name='txtLongestPeriodOfSobrietyWhen' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Has the client received treatment for drug and alcohol issues?</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtClientReceivedTreatmentForDrugIssues' name='txtClientReceivedTreatmentForDrugIssues' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>If yes, list inpatient providers, outpatient, providers, services received, dates of services, and outcomes</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtClientReceivedTreatmentForDrugIssuesListDetails' name='txtClientReceivedTreatmentForDrugIssuesListDetails' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'><h3>Patient Evaluation</h3></p>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Mental Status</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtMentalStatus' name='txtMentalStatus' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Additional Comments</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtMentalStatusAdditionalComments' name='txtMentalStatusAdditionalComments' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'><h3>Mental Health Services History</h3></p>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Current and past psychiatric history</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtPsychiatricHistory' name='txtPsychiatricHistory' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Current service provider(s)</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurentServiceProvider' name='txtCurentServiceProvider' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Past service provider(s)</span>
            <span className='small'>(Document significant past and present medical conditions, including allergies.)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtPastServiceProvider' name='txtPastServiceProvider' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Family Medical History</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtFamilyMedicalHistory' name='txtFamilyMedicalHistory' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-500'><span className='eleHeader'>Primary Care Physician's Contact Information</span></td>
        <td className='w-250'><span className='eleHeader'>Date of last physical examinations</span></td>
    </tr>
    <tr>
        <td className='w-500'><input type='text' id='txtPrimaryCarePhysicianContactInformation' name='txtPrimaryCarePhysicianContactInformation' className='add-only' /></td>
        <td className='w-250'><input type='date' id='txtDateOfLastPhysicalExaminations' name='txtDateOfLastPhysicalExaminations' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Current with immunizations?</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentWithImmunizations' name='txtCurrentWithImmunizations' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>List alternative treatments/therapies</span>
            <span className='small'>(ie: biofeedback, acupuncture, hypnosis, etc.)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtListAlternativeTreatments' name='txtListAlternativeTreatments' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>If lab tests were done, list the results</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtIfLabsTestsWereDoneResults' name='txtIfLabsTestsWereDoneResults' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Daily Living Skills (Personal Care, Laundry, Cleaning)</span>
            <span className='small'>(List all tasks that consumer is able to complete/strengths)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtDailyLivingSkills' name='txtDailyLivingSkills' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Does client require assistive technology?</span>
            <span className='small'>(if yes, specify what is needed)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtDoesClientAssistiveTechnology' name='txtDoesClientAssistiveTechnology' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Does client display impairment in</span></td>
    </tr>
    <tr>
        <td className='w-250'><input type='checkbox' id='cbImpairmentSpeech' name='cbImpairmentSpeech' className='add-only' value='Speech' /> Speech</td>
        <td className='w-250'><input type='checkbox' id='cbImpairmentLanguage' name='cbImpairmentLanguage' className='add-only' value='Language' /> Language</td>
        <td className='w-250'><input type='checkbox' id='cbImpairmentVision' name='cbImpairmentVision' className='add-only' value='Vision' /> Vision</td>
    </tr>

    <tr>
        <td className='w-750'><span className='eleHeader'>Social/Leisure Assessment</span>
            <span className='small'>(Consumer's sexual orientation, sexual behaviors, gender identity)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtSocialLeisureAssessment' name='txtSocialLeisureAssessment' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-500'><span className='eleHeader'>Consumers Height</span></td>
        <td className='w-250'><span className='eleHeader'>Consumers Weight</span></td>
    </tr>
    <tr>
        <td className='w-500'><input type='text' id='txtConsumersHeight' name='txtConsumersHeight' className='add-only' /></td>
        <td className='w-250'><input type='date' id='txtConsumersWeight' name='txtConsumersWeight' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-500'><span className='eleHeader'>Consumer Satisfied with Current Weight?</span></td>
        <td className='w-250'><span className='eleHeader'>Eat Three Meals per Day?</span></td>
    </tr>
    <tr>
        <td className='w-500'><input type='text' id='txtSatisfiedWithCurrentWeight' name='txtSatisfiedWithCurrentWeight' className='add-only' /></td>
        <td className='w-250'><input type='date' id='txtEatThreeMealsDay' name='txtEatThreeMealsDay' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-500'><span className='eleHeader'>Ever Diagnosed with an Eating Disorder?</span></td>
        <td className='w-250'><span className='eleHeader'>Consumer Need a Referral for a Nutritional Assessment?</span></td>
    </tr>
    <tr>
        <td className='w-500'><input type='text' id='txtDiagnosedEatingDisorder' name='txtDiagnosedEatingDisorder' className='add-only' /></td>
        <td className='w-250'><input type='date' id='txtReferralForNutritionalAssessment' name='txtReferralForNutritionalAssessment' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'><h3>Medication History</h3></p>

<table>


    <tr>
        <td className='w-750'><b>Medication #1</b></td>
    </tr>
    <tr>
        <td className='w-375'><span className='eleHeader'>Medication Name</span></td>
        <td className='w-375'><span className='eleHeader'>Dosage/Frequency</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtMedicationName_1' name='txtMedicationName_1' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtDosageFrequency_1' name='txtDosageFrequency_1' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Effective?</span>
            <span className='small'>(Explain)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtMedicationEffectiveExplain_1' name='txtMedicationEffectiveExplain_1' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-375'><span className='eleHeader'>Compliance</span></td>
        <td className='w-375'><span className='eleHeader'>Physician Name/Phone Number</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtCompliance_1' name='txtCompliance_1' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtPhysicianNameNumber_1' name='txtPhysicianNameNumber_1' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><b>Medication #2</b></td>
    </tr>
    <tr>
        <td className='w-375'><span className='eleHeader'>Medication Name</span></td>
        <td className='w-375'><span className='eleHeader'>Dosage/Frequency</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtMedicationName_2' name='txtMedicationName_2' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtDosageFrequency_2' name='txtDosageFrequency_2' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Effective?</span>
            <span className='small'>(Explain)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtMedicationEffectiveExplain_2' name='txtMedicationEffectiveExplain_2' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-375'><span className='eleHeader'>Compliance</span></td>
        <td className='w-375'><span className='eleHeader'>Physician Name/Phone Number</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtCompliance_2' name='txtCompliance_2' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtPhysicianNameNumber_2' name='txtPhysicianNameNumber_2' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><b>Medication #3</b></td>
    </tr>
    <tr>
        <td className='w-375'><span className='eleHeader'>Medication Name</span></td>
        <td className='w-375'><span className='eleHeader'>Dosage/Frequency</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtMedicationName_3' name='txtMedicationName_3' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtDosageFrequency_3' name='txtDosageFrequency_3' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Effective?</span>
            <span className='small'>(Explain)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtMedicationEffectiveExplain_3' name='txtMedicationEffectiveExplain_3' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-375'><span className='eleHeader'>Compliance</span></td>
        <td className='w-375'><span className='eleHeader'>Physician Name/Phone Number</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtCompliance_3' name='txtCompliance_3' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtPhysicianNameNumber_3' name='txtPhysicianNameNumber_3' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><b>Medication #4</b></td>
    </tr>
    <tr>
        <td className='w-375'><span className='eleHeader'>Medication Name</span></td>
        <td className='w-375'><span className='eleHeader'>Dosage/Frequency</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtMedicationName_4' name='txtMedicationName_4' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtDosageFrequency_4' name='txtDosageFrequency_4' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Effective?</span>
            <span className='small'>(Explain)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtMedicationEffectiveExplain_4' name='txtMedicationEffectiveExplain_4' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-375'><span className='eleHeader'>Compliance</span></td>
        <td className='w-375'><span className='eleHeader'>Physician Name/Phone Number</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtCompliance_4' name='txtCompliance_4' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtPhysicianNameNumber_4' name='txtPhysicianNameNumber_4' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><b>Medication #5</b></td>
    </tr>
    <tr>
        <td className='w-375'><span className='eleHeader'>Medication Name</span></td>
        <td className='w-375'><span className='eleHeader'>Dosage/Frequency</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtMedicationName_5' name='txtMedicationName_5' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtDosageFrequency_5' name='txtDosageFrequency_5' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Effective?</span>
            <span className='small'>(Explain)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtMedicationEffectiveExplain_5' name='txtMedicationEffectiveExplain_5' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-375'><span className='eleHeader'>Compliance</span></td>
        <td className='w-375'><span className='eleHeader'>Physician Name/Phone Number</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtCompliance_5' name='txtCompliance_5' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtPhysicianNameNumber_5' name='txtPhysicianNameNumber_5' className='add-only' /></td>
    </tr>
</table>

<table>
    <tr>
        <td className='w-375'><span className='eleHeader'>What is your preferred sexual orientation?</span></td>
        <td className='w-375'><span className='eleHeader'>How many partners have you had?</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtPreferredSexualOrientation' name='txtPreferredSexualOrientation' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtHowManyPartnersYouHad' name='txtHowManyPartnersYouHad' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-375'><span className='eleHeader'>How many partners do you currently have?</span></td>
        <td className='w-375'><span className='eleHeader'>What was the last STD check?</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtHowManyPartnersYouCurrentlyHave' name='txtHowManyPartnersYouCurrentlyHave' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtWhatWasTheLastStdCheck' name='txtWhatWasTheLastStdCheck' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-250'><span className='eleHeader'>Have you ever had sex against your will?</span></td>
        <td className='w-250'><span className='eleHeader'>Have you ever traded sex for food, money, clothing, shelter, or drugs?</span></td>
        <td className='w-250'><span className='eleHeader'>Physician Name/Phone Number</span></td>
    </tr>
    <tr>
        <td className='w-250'><input type='text' id='txtHadSexAgainstYourWill' name='txtHadSexAgainstYourWill' className='add-only' /></td>
        <td className='w-250'><input type='text' id='txtTradedSexForFoodMoneyDrugs' name='txtTradedSexForFoodMoneyDrugs' className='add-only' /></td>
        <td className='w-250'><input type='text' id='txtPhysicianNameNumber' name='txtPhysicianNameNumber' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'><h3>Current Symptoms/Problems</h3><br />
    <b>Rate severity and duration for each</b>
</p>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Anxiety</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsAnxiety' name='txtCurrentSymptomsAnxiety' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Phobia</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsPhobia' name='txtCurrentSymptomsPhobia' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Somatization</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsSomatization' name='txtCurrentSymptomsSomatization' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Impaired Memory</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsImpairedMemory' name='txtCurrentSymptomsImpairedMemory' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Loss of Interest</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsLossInterest' name='txtCurrentSymptomsLossInterest' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Sleep Disturbance</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsSleepDisturbance' name='txtCurrentSymptomsSleepDisturbance' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Weight Change</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsWeightChange' name='txtCurrentSymptomsWeightChange' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Bizarre Behavior</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsBizarreBehavior' name='txtCurrentSymptomsBizarreBehavior' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Gender Issues</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsGenderIssues' name='txtCurrentSymptomsGenderIssues' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Poor Judgment</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsPoorJudgment' name='txtCurrentSymptomsPoorJudgment' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Poor Interpersonal Skills</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsPoorInterpersonalSkills' name='txtCurrentSymptomsPoorInterpersonalSkills' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>School Problems</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsSchoolProblems' name='txtCurrentSymptomsSchoolProblems' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Independent Living Problems</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsIndependentLivingProblems' name='txtCurrentSymptomsIndependentLivingProblems' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Panic Attacks</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsPanicAttacks' name='txtCurrentSymptomsPanicAttacks' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Obsessive Compulsive</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsObsessiveCompulsive' name='txtCurrentSymptomsObsessiveCompulsive' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Depression</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsDepression' name='txtCurrentSymptomsDepression' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Poor Self Care Skills</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsPoorSelfCareSkills' name='txtCurrentSymptomsPoorSelfCareSkills' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Sexual Dysfunction</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsSexualDysfunction' name='txtCurrentSymptomsSexualDysfunction' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Appetite Disturbance</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsAppetiteDisturbance' name='txtCurrentSymptomsAppetiteDisturbance' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Bizarre Ideation</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsBizarreIdeation' name='txtCurrentSymptomsBizarreIdeation' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Paranoid Ideation</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsParanoidIdeation' name='txtCurrentSymptomsParanoidIdeation' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Eating Disorders</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsEatingDisorders' name='txtCurrentSymptomsEatingDisorders' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Lack of Support System</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsLackSupportSystem' name='txtCurrentSymptomsLackSupportSystem' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Conduct Problems</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsConductProblems' name='txtCurrentSymptomsConductProblems' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Family Problems</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsFamilyProblems' name='txtCurrentSymptomsFamilyProblems' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Unusual Body Movements</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentSymptomsUnusualBodyMovements' name='txtCurrentSymptomsUnusualBodyMovements' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'><b>Please describe symptoms/problems listed above in detail</b>
    <textarea id='txtCurrentSymptomsDescribeInDetails' name='txtCurrentSymptomsDescribeInDetails' className='add-only' ></textarea>
</p>

<p className='w-750'><h3>Risk Assessment</h3></p>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Impulse Control</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtRiskAssessmentImpulseControl' name='txtRiskAssessmentImpulseControl' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-250'><span className='eleHeader'>Substance Abuse</span></td>
        <td className='w-250'><span className='eleHeader'>Substance Abuse Date of Last Usage</span></td>
        <td className='w-250'><span className='eleHeader'>Substance Abuse Age of First Usage</span></td>
    </tr>
    <tr>
        <td className='w-250'><input type='text' id='txtRiskAssessmentSubstanceAbuse' name='txtRiskAssessmentSubstanceAbuse' className='add-only' /></td>
        <td className='w-250'><input type='date' id='txtRiskAssessmentSubstanceAbuseDateLastUse' name='txtRiskAssessmentSubstanceAbuseDateLastUse' className='add-only' /></td>
        <td className='w-250'><input type='date' id='txtRiskAssessmentSubstanceAbuseDateFirstUse' name='txtRiskAssessmentSubstanceAbuseDateFirstUse' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-250'><span className='eleHeader'>Sexual Abuse Victim/Perpetrator?</span></td>
        <td className='w-250'><span className='eleHeader'>Access to Public or Private Transportation</span></td>
        <td className='w-250'><span className='eleHeader'>Medical Risks</span></td>
    </tr>
    <tr>
        <td className='w-250'><input type='text' id='txtRiskAssessmentSexualAbuseVictimPerpetrator' name='txtRiskAssessmentSexualAbuseVictimPerpetrator' className='add-only' /></td>
        <td className='w-250'><input type='text' id='txtRiskAssessmentAccessPublicPrivateTransportation' name='txtRiskAssessmentAccessPublicPrivateTransportation' className='add-only' /></td>
        <td className='w-250'><input type='text' id='txtRiskAssessmentMedicalRisks' name='txtRiskAssessmentMedicalRisks' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'><b>Please explain all "Yes" answers from above</b>
    <textarea id='txtRiskAssessmentExplainAllAbove' name='txtRiskAssessmentExplainAllAbove' className='add-only' ></textarea>
</p>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Risk History</span>
            <span className='small'>(Explain any significant history of suicidal, homicidal, impulse control, medical or substance abuse behavior that
                may affect client's current level of risk or impairment to functioning. Include description of plan/ideation/intent
                checked above.)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtRiskAssessmentHistory' name='txtRiskAssessmentHistory' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'><h3>Summary of Consumer's SNAPS </h3>
    <span className='small'>(Strengths, Needs, Abilities, Preferences)</span>

    Consumer's Goals/Hopes for the Future
</p>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>What things do you like about yourself?</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtSummaryOfConsumerYouLikeAboutYourself' name='txtSummaryOfConsumerYouLikeAboutYourself' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>What things would you like to improve?</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtSummaryOfConsumerThingsYouLikeToImprove' name='txtSummaryOfConsumerThingsYouLikeToImprove' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>What are your goals for improving these behaviors?</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtSummaryOfConsumerImprovingBehaviors' name='txtSummaryOfConsumerImprovingBehaviors' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>What accomplishments are you most proud of in your personal life?</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtSummaryOfConsumerAccomplishmentYouAreProudOf' name='txtSummaryOfConsumerAccomplishmentYouAreProudOf' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Consumer's and family's expectations from participating in this program?</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtSummaryOfConsumerFamilyExpectation' name='txtSummaryOfConsumerFamilyExpectation' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Strengths</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtSummaryOfConsumerStrengths' name='txtSummaryOfConsumerStrengths' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Needs</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtSummaryOfConsumerNeeds' name='txtSummaryOfConsumerNeeds' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Abilities</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtSummaryOfConsumerAbilities' name='txtSummaryOfConsumerAbilities' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Preferences</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtSummaryOfConsumerPreferences' name='txtSummaryOfConsumerPreferences' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Summary of Findings/Formulation</span>
            <span className='small'>(Identify problem areas and underlying dynamics. Include information used to make differential diagnosis.)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtSummaryOfConsumerFindings' name='txtSummaryOfConsumerFindings' className='add-only' /></td>
    </tr>
</table>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Recommended Services</span><span className='small'>(Check all that apply)</span></td>
    </tr>
    <tr>
        <td className='w-250'><input type='checkbox' id='cbLongTermTherapy' name='cbLongTermTherapy' className='add-only' value='LongTermTherapy' /> Long-term therapy</td>
        <td className='w-250'><input type='checkbox' id='cbGroup' name='cbGroup' className='add-only' value='Group' /> Group</td>
        <td className='w-250'><input type='checkbox' id='cbMedicationAssessment' name='cbMedicationAssessment' className='add-only' value='MedicationAssessment' /> Medication assessment</td>
    </tr>
    <tr>
        <td className='w-250'><input type='checkbox' id='cbIndividualTherapy' name='cbIndividualTherapy' className='add-only' value='IndividualTherapy' /> Individual therapy</td>
        <td className='w-250'><input type='checkbox' id='cbFamilyTherapy' name='cbFamilyTherapy' className='add-only' value='FamilyTherapy' /> Family therapy</td>
        <td className='w-250'><input type='checkbox' id='cbTesting' name='cbTesting' className='add-only' value='Testing' /> Testing</td>
    </tr>
    <tr>
        <td className='w-250'><input type='checkbox' id='cbBriefTherapy' name='cbBriefTherapy' className='add-only' value='BriefTherapy' /> Brief therapy</td>
        <td className='w-250'><input type='checkbox' id='cbCollateral' name='cbCollateral' className='add-only' value='Collateral' /> Collateral</td>
        <td className='w-250'><input type='checkbox' id='cbDayRehabTreatment' name='cbDayRehabTreatment' className='add-only' value='DayRehabTreatment' /> Day rehab/treatment</td>
    </tr>
    <tr>
        <td className='w-250'><input type='checkbox' id='cbByPrimaryCarePhysician' name='cbByPrimaryCarePhysician' className='add-only' value='ByPrimaryCarePhysician' /> By primary care physician</td>
        <td className='w-250'><input type='checkbox' id='cbByAsocCsogPsychiatrist' name='cbByAsocCsogPsychiatrist' className='add-only' value='ByAsocCsogPsychiatrist' /> By ASOC or CSOG psychiatrist</td>
    </tr>
    <tr>
        <td className='w-500'><input type='checkbox' id='cbCommunityReferralsServicesNeeded' name='cbCommunityReferralsServicesNeeded' className='add-only' value='CommunityReferralsServicesNeeded' /> Community referrals made, no further services needed</td>
        <td className='w-250'><input type='checkbox' id='cbRecommendedServicesOtherOther' name='cbRecommendedServicesOtherOther' className='add-only' value='RecommendedServicesOtherOther' /> Other</td>
    </tr>

    <tr>
        <td className='w-750'><span className='eleHeader'>If community referrals were made, please describe</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCommunityReferralsWereMadeDescribe' name='txtCommunityReferralsWereMadeDescribe' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'><span className='eleHeader'>If client was placed on 1013, please give details</span>
    <span className='small'>(ie: which hospital, how transported, etc.)</span>
    <textarea id='txtIfClientPlacedIn1013GiveDetails' name='txtIfClientPlacedIn1013GiveDetails' className='add-only' ></textarea>
</p>
<p className='w-750'><span className='eleHeader'>Interpretive Summary</span>
    <textarea id='txtInterpretiveSummary' name='txtInterpretiveSummary' className='add-only' ></textarea>
</p>
<p className='w-750'><span className='eleHeader'>Problems List</span>
    <textarea id='txtProblemsList' name='txtProblemsList' className='add-only' ></textarea>
</p>

<p className='w-750'><h3>Diagnostic Impressions</h3></p>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>List Diagnosis and Date</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtListDiagnosisDate' name='txtListDiagnosisDate' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>CAFAS/PECFAS (Child)</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCafasPecafasChild' name='txtCafasPecafasChild' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>LOCUS (Adult)</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtLocusAdult' name='txtLocusAdult' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Recommendations</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtDiagnosticSummaryRecommendations' name='txtDiagnosticSummaryRecommendations' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Projected Date of Discharge/Transition</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtProjectedDateDischargeTransition' name='txtProjectedDateDischargeTransition' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Anticipated Stepdown</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtAnticipatedStepdown' name='txtAnticipatedStepdown' className='add-only' /></td>
    </tr>
</table>


            </div>
        </form>

    )
}











